import { useAudit, useVerifyAudit } from '../api/hooks';
import { ErrorNote, Loading, PageHead, formatDateTime } from '../components/ui';

export function AuditPage() {
  const audit = useAudit(100);
  const verify = useVerifyAudit();
  return (
    <>
      <PageHead
        eyebrow="Traçabilité"
        title="Journal d'audit"
        actions={
          <button className="btn" disabled={verify.isPending} onClick={() => verify.mutate()}>
            {verify.isPending ? 'Vérification…' : 'Vérifier la chaîne'}
          </button>
        }
      >
        Chaque action et chaque lecture sensible, chaînées par empreinte. Cette consultation est elle-même journalisée.
      </PageHead>
      {verify.data && (
        <div className={`note ${verify.data.ok ? '' : 'bad'}`}>
          {verify.data.ok
            ? `Chaîne intacte : ${verify.data.checked} événement(s) vérifié(s).`
            : `Rupture détectée au rang ${verify.data.brokenAtSeq} sur ${verify.data.checked} événement(s).`}
        </div>
      )}
      <ErrorNote error={verify.error} />
      <ErrorNote error={audit.error} />
      {audit.isPending ? (
        <Loading />
      ) : (
        <div className="tw">
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Quand</th>
                <th>Qui</th>
                <th>Action</th>
                <th>Entité</th>
                <th>Requête</th>
                <th>Empreinte</th>
              </tr>
            </thead>
            <tbody>
              {(audit.data ?? []).map((e) => (
                <tr key={e.id}>
                  <td className="num">{e.seq}</td>
                  <td className="small">{formatDateTime(e.occurredAt)}</td>
                  <td>
                    {e.actorLabel} <span className="muted small">({e.actorRoles.join(', ')})</span>
                  </td>
                  <td className="mono">{e.action}</td>
                  <td className="small">
                    {e.entityType}
                    {e.entityId && <span className="muted mono"> {e.entityId.slice(0, 8)}…</span>}
                  </td>
                  <td className="mono small muted">{e.requestId?.slice(0, 8)}…</td>
                  <td className="mono small muted">{e.hash.slice(0, 12)}…</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
